const es = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    myDashboard: 'Mi Dashboard',
    shipments: 'Embarques',
    tracking: 'Tracking',
    payments: 'Pagos',
    myPayments: 'Mi Balance',
    arnulfo: 'Arnulfo',
    pricing: 'Precios',
    certificates: 'Certificados',
    alerts: 'Alertas',
    email: 'Correo',
    reports: 'Reportes',
    sla: 'Rendimiento',
    operationsAnalytics: 'Operaciones por parte',
    superAdmin: 'Super Admin',
    audit: 'Auditoria',
    clients: 'Clientes',
    importers: 'Importadoras',
    suppliers: 'Proveedores',
    catalogs: 'Catalogos',
    users: 'Usuarios',
    adminMaster: 'Admin Maestro',
    clientView: 'Vista Cliente',
    aiArancel: 'IA Arancel',
    logout: 'Cerrar Sesion',
  },
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    noData: 'No hay datos',
    actions: 'Acciones',
    status: 'Estatus',
    date: 'Fecha',
    name: 'Nombre',
    yes: 'Si',
    no: 'No',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    confirm: 'Confirmar',
    apply: 'Aplicar',
    all: 'Todos',
    none: 'Ninguno',
    unknown: 'Desconocida',
    notAvailable: 'No disponible',
    success: 'Exitoso',
    error: 'Error',
    viewMore: 'Ver mas',
    viewLess: 'Ver menos',
    created: 'Creado',
    updated: 'Actualizado',
    noResults: 'Sin resultados',
    total: 'Total',
    of: 'de',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    configure: 'Configurar',
    details: 'Detalles',
    download: 'Descargar',
    upload: 'Subir',
    select: 'Seleccionar',
    required: 'Obligatorio',
    optional: 'Opcional',
    new: 'Nuevo',
    create: 'Crear',
    unassigned: 'Sin asignar',
    select: 'Seleccionar',
    description: 'Descripcion',
    notes: 'Notas',
    type: 'Tipo',
    from: 'Desde',
    to: 'Hasta',
    period: 'Período',
    errorSaving: 'Error al guardar',
    errorDeleting: 'Error al eliminar',
    errorLoading: 'Error al cargar datos',
    errorUpdating: 'Error al actualizar',
    errorCreating: 'Error al crear',
    savedOk: 'Guardado exitosamente',
    deletedOk: 'Eliminado exitosamente',
    updatedOk: 'Actualizado exitosamente',
    createdOk: 'Creado exitosamente',
    passwordsNoMatch: 'Las contrasenas no coinciden',
    passwordTooShort: 'La contrasena debe tener al menos 6 caracteres',
    passwordUpdated: 'Contrasena actualizada correctamente',
    emailResetSent: 'Si el email existe, recibiras un enlace para restablecer tu contrasena',
    pdfOnly: 'Solo archivos PDF',
    fieldRequired: 'Campo requerido',
    nameRequired: 'El nombre es requerido',
    codeAndLabelRequired: 'Codigo y etiqueta son requeridos',
    contactFormSuccess: 'Gracias! Nos pondremos en contacto pronto.',
    contactFormError: 'Error al enviar. Intenta de nuevo.',
    contactFormRequired: 'Por favor completa los campos requeridos',
    processingExcel: 'Procesando archivo Excel...',
    errorToggleStatus: 'Error al cambiar estado',
    statusChanged: 'Estado actualizado',
    noPermission: 'No tienes permiso para acceder',
    selectAtLeastOneField: 'Selecciona al menos un campo para actualizar',
    creating: 'Creando...',
    saving: 'Guardando...',
    update: 'Actualizar',
    yes: 'Si',
    no: 'No',
    select: 'Seleccionar...',
  },
  // Auth / Login
  auth: {
    login: 'Iniciar Sesion',
    loginTitle: 'Iniciar Sesion',
    loginSubtitle: 'Ingresa tus credenciales para acceder al sistema',
    email: 'Correo electronico',
    password: 'Contrasena',
    forgotPassword: 'Olvidaste tu contrasena?',
    noAccount: 'No tienes cuenta? Solicita acceso',
    welcome: 'Bienvenido',
    rememberMe: 'Recordarme',
    loginButton: 'Iniciar Sesion',
    showDemo: 'Visitar en modo demo',
  },
  // Landing
  landing: {
    heroTitle: 'Sistema de gestion de operaciones de importacion',
    heroSubtitle: 'Control total de tus embarques y contenedores',
    getStarted: 'Comenzar',
    login: 'Iniciar Sesion',
  },
  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Resumen de contenedores en tiempo real',
    totalContainers: 'Total Contenedores',
    activeContainers: 'Contenedores Activos',
    delivered: 'Entregados',
    inTransit: 'En Transito',
    inPort: 'En Proceso',
    pending: 'Pendientes',
    avgDaysInPort: 'Prom. Dias en Puerto',
    containerEvolution: 'Evolucion de Contenedores',
    containerStatus: 'Contenedores por Estatus',
    currentDistribution: 'Distribucion actual',
    arrivalsVsDeliveries: 'Arribos vs Entregas',
    recentActivity: 'Actividad Reciente',
    certificates: 'Certificados',
    expiring: 'por vencer',
    expired: 'vencidos',
    allValid: 'Todos los certificados vigentes',
    viewAllCertificates: 'Ver todos los certificados',
    daysRemaining: 'restantes',
    daysExpired: 'Vencido',
    staleSync: 'Sync atrasado',
    staleSyncDesc: 'Liberados sin actualización en >24h',
    staleSyncOne: 'caso',
    staleSyncMany: 'casos',
    staleSyncEmpty: 'Todos los contenedores liberados están sincronizando bien',
    staleSyncViewHealth: 'Ver salud de sincronización',
    customize: 'Personalizar',
    newShipment: 'Nuevo Embarque',
    navigating: 'Navegando',
    waitingDelivery: 'Esperando entrega',
    arrivalToDelivery: 'Arribo a entrega',
    monthlyHistoric: 'Mostrando historico mensual',
    useDateFilter: 'Usa el filtro de fechas para ver un período específico',
    portAlerts: 'Alertas de Puerto',
    pendingCosts: 'Costos Pendientes',
    deliveredContainers: 'Contenedores Entregados',
    monthlySummary: 'Resumen Mensual',
    clientsChart: 'Distribucion por Cliente',
    importerChart: 'Distribucion por Importadora',
    widgetSettings: 'Configurar Widgets',
    widgetSettingsDesc: 'Selecciona los widgets que quieres ver en tu dashboard',
    arrivals: 'Arribos',
    deliveriesLabel: 'Entregas',
    topClients: 'Top Clientes',
    topClientsByContainers: 'Top Clientes por Contenedores',
    containersByImporter: 'Contenedores por Importadora',
    noClient: 'Sin cliente',
    noImporter: 'Sin importadora',
    containersUnit: 'contenedores',
    periodComparison: 'Comparativo de Períodos',
    previousMonth: 'Mes anterior',
    currentMonth: 'Mes actual',
    comparing: 'Comparando...',
    compare: 'Comparar',
    metric: 'Métrica',
    current: 'Actual',
    previous: 'Anterior',
    change: 'Cambio',
    containersArrived: 'Cont. Arribados',
    containersDelivered: 'Cont. Entregados',
    newShipments: 'Nuevos Embarques',
    etaPredictionEngine: 'Motor de Predicción ETA',
    basedOnHistorical: 'Basado en históricos',
    calculating: 'Calculando...',
    calculateEtas: 'Calcular ETAs',
    overallAverage: 'Promedio general',
    days: 'días',
    range: 'Rango',
    samples: 'muestras',
    clickForDetail: 'Click para ver análisis detallado',
    byClientTop5: 'Por cliente (top 5)',
    noName: 'Sin nombre',
    byPort: 'Por puerto',
    noPort: 'Sin puerto',
    avgDaysDescription: 'Dias promedio desde arribo a puerto hasta entrega',
    deliveryTimes: 'Tiempos de Entrega',
    detailedAnalysis: 'Análisis Detallado de Tiempos de Entrega',
    detailedAnalysisDesc: 'Analiza los tiempos de entrega por diferentes factores y períodos',
    periodFilterLabel: 'Período:',
    clear: 'Limpiar',
    periodAverage: 'Promedio del período',
    deliveriesAnalyzed: 'entregas analizadas',
    tabSummary: 'Resumen',
    tabByClient: 'Por Cliente',
    tabByPort: 'Por Puerto',
    tabByCarrier: 'Por Naviera',
    tabByDestination: 'Por Destino',
    tabTrend: 'Tendencia',
    noDataAvailable: 'Sin datos disponibles',
    noDataInRange: 'No hay datos en el rango seleccionado',
    useDateFilterFull: 'Usa el filtro de fechas para ver un período específico',
    year: 'Año',
    preferencesSaved: 'Preferencias guardadas',
    preferencesError: 'Error al guardar preferencias',
    etaError: 'Error calculando ETAs',
    etaSuccess: 'ETAs calculados correctamente',
    recentShipments: 'Embarques Recientes',
    viewAll: 'Ver todos',
    mblBl: 'MBL/BL',
    client: 'Cliente',
    statusCol: 'Estatus',
    containersCol: 'Contenedores',
    lastUpdate: 'Ultima Actualizacion',
    noShipmentsRegistered: 'No hay embarques registrados',
    daysInPortLabel: 'días en puerto',
    noActiveAlerts: 'Sin alertas activas',
    allCostsCalculated: 'Todos los costos calculados',
    deliveredTitle: 'Entregados',
    containersCompleted: 'Contenedores completados',
    noDeliveriesInPeriod: 'No hay entregas en el período',
    viewMore: 'Ver',
    more: 'm\u00e1s',
    viewLess: 'Ver menos',
    expiringCertificates: 'Certificados por Vencer',
    expiredCount: 'vencidos',
    deliveriesCount: 'entregas',
    notCalculated: 'Sin calcular',
    backToAutoData: 'Volver a datos automáticos',
    expiredDaysAgo: 'Vencido',
    daysRemaining: 'restantes',
  },
  // Shipments
  shipments: {
    title: 'Embarques',
    subtitle: 'Gestion de embarques y contenedores',
    newShipment: 'Nuevo Embarque',
    mbl: 'MBL',
    client: 'Cliente',
    importer: 'Importadora',
    supplier: 'Proveedor',
    origin: 'Origen',
    destination: 'Destino',
    port: 'Puerto',
    etaReal: 'ETA Real',
    entregaReal: 'Entrega Real',
    containers: 'Contenedores',
    timeline: 'Timeline',
    costs: 'Costos',
    internalNotes: 'Notas Internas',
    pedimentos: 'Pedimentos',
    documents: 'Documentos',
    history: 'Historial',
    information: 'Informacion',
    addContainers: 'Agregar Contenedores',
    containerNumber: 'Contenedor',
    carrier: 'Naviera',
    trafficLight: 'Semaforo',
    arrival: 'Arribo',
    delivery: 'Entrega',
    refCarga: 'Ref. Carga',
    pedimento: 'Pedimento',
    daysInPort: 'Dias Puerto',
    quickEdit: 'Edicion Rapida',
    transport: 'Transporte',
    train: 'Tren',
    truck: 'Camion',
    pending: 'Pendiente',
    reference: 'Referencia',
    number: 'Numero',
    route: 'Ruta',
    inProgress: 'En Proceso',
    completed: 'Completado',
    dates: 'Fechas',
    containerNumbers: 'Numeros de Contenedor',
    paid: 'Pagado',
    bulkSelect: 'contenedor(es) seleccionado(s)',
    deselect: 'Deseleccionar',
    noContainers: 'No hay contenedores registrados',
    sortAZ: 'A-Z',
    sortZA: 'Z-A',
    sortNewest: 'Mas reciente',
    sortOldest: 'Mas antiguo',
    noShipments: 'No hay embarques',
    searchPlaceholder: 'Buscar por MBL, cliente, importadora...',
    generalStatus: 'Estatus General',
    totalShipments: 'embarques',
    containersPending: 'contenedores pendientes',
    editShipment: 'Editar Embarque',
    deleteShipment: 'Eliminar Embarque',
    shipmentDetails: 'Detalle del Embarque',
    free: 'Libre',
    inspection: 'Inspeccion',
    na: 'N/A',
    enterContainerNumbers: 'Ingresa los numeros de contenedor, uno por linea',
    updated: 'contenedores actualizados',
    onlyFilledFields: 'Solo los campos con valor seran actualizados',
    noChange: 'Sin cambio',
    applyTo: 'Aplicar a',
    arrivalDate: 'Fecha Arribo',
    deliveryDate: 'Fecha Entrega',
    viewLess: 'Ver menos',
    viewMore: 'Ver mas',
    exportingExcel: 'Generando archivo Excel...',
    exportedOk: 'Archivo exportado correctamente',
    exportError: 'Error al exportar',
    deleteError: 'Error al eliminar embarque',
    mblChangeError: 'Error al cambiar MBL',
    bulkUpdateError: 'Error en actualizacion masiva',
    generatingTemplate: 'Generando plantilla Excel...',
    templateDownloaded: 'Plantilla descargada. Edita el archivo y subelo para aplicar cambios.',
    bulkImportInstructions1: 'Descarga la plantilla Excel con el boton "Excel"',
    bulkImportInstructions2: 'Edita las celdas verdes (las grises son de solo lectura)',
    bulkImportInstructions3: 'Guarda el archivo y subelo aqui',
    errorLoadingShipment: 'Error al cargar el embarque',
    errorSaving: 'Error al guardar',
    errorAddingContainers: 'Error al agregar contenedores',
    errorUpdatingContainer: 'Error al actualizar',
    errorDeletingContainer: 'Error al eliminar',
    errorCreatingEvent: 'Error al crear evento',
    errorCreatingNote: 'Error al crear nota',
    errorUploadingImage: 'Error al subir imagen',
    savedChanges: 'Cambios guardados',
    containersAdded: 'Contenedores agregados',
    containerDeleted: 'Contenedor eliminado',
    eventCreated: 'Evento creado',
    eventDeleted: 'Evento eliminado',
    noteCreated: 'Nota creada',
    noteDeleted: 'Nota eliminada',
    imageUploaded: 'Imagen subida',
    errorCreatingPort: 'Error al crear puerto',
    portCreated: 'Puerto creado',
    clientCreated: 'Cliente creado',
    errorCreatingClient: 'Error al crear cliente',
    importerCreated: 'Importadora creada',
    errorCreatingImporter: 'Error al crear importadora',
    supplierCreated: 'Proveedor creado',
    errorCreatingSupplier: 'Error al crear proveedor',
    mblRequired: 'El MBL/BL es requerido',
    clientRequired: 'El cliente es requerido',
    shipmentCreated: 'Embarque creado exitosamente',
    errorCreatingShipment: 'Error al crear embarque',
    // Filters / actions header
    excel: 'Excel',
    uploadExcel: 'Subir Excel',
    prePedimento: 'Proforma',
    prePedimentoBulk: 'Proforma (lote)',
    repairSync: 'Reparar Sync',
    calcEtas: 'Calcular ETAs',
    notDelivered: 'No Entregados',
    deliveryStatus: 'Estado de Entrega',
    inOperation: 'En operación (no entregados)',
    deliveredOnly: 'Solo entregados',
    dates: 'Fechas',
    advanced: 'Avanzados',
    allClients: 'Todos los clientes',
    allImporters: 'Todas las importadoras',
    allStatus: 'Todos los estatus',
    active: 'Activos',
    inactive: 'Inactivos',
    all: 'Todos',
    // Advanced filters
    advancedFilters: 'Filtros Avanzados',
    carrier: 'Naviera',
    terminal: 'Terminal',
    customsAgent: 'Agente Aduanal',
    customsTrafficLight: 'Semáforo Aduana',
    withPedimento: 'Con pedimento',
    withoutPedimento: 'Sin pedimento',
    delayInPort: 'Retraso en puerto (días ≥)',
    clearAdvanced: 'Limpiar avanzados',
    clearDates: 'Limpiar fechas',
    arrivalAtPort: 'Arribo a Puerto',
    arrivalAtPortHint: 'Usa ETA Real, si no hay usa ETA Inicial',
    deliveryHint: 'Fecha real de entrega al cliente',
    partialMatch: 'Nombre parcial...',
    redLight: '🔴 Rojo',
    greenLight: '🟢 Verde',
    noLight: 'Sin dato',
    contNumberPlaceholder: '# Contenedor',
    cargoTypePlaceholder: 'Tipo Carga',
    referencePlaceholder: 'Referencia',
    pedimentoPlaceholder: 'Pedimento',
    // Action buttons
    newShipment: 'Nuevo Embarque',
    actions: 'Acciones',
    // Table headers
    client: 'Cliente',
    importer: 'Importadora',
    cargoType: 'Tipo Carga',
    status: 'Estatus',
    docs: 'Docs',
    docsHint: 'Documentos enviados al agente aduanal',
    containers: 'Cont.',
    days: 'Días',
    daysHint: 'Días desde arribo hasta entrega',
    initialEta: 'ETA Inicial',
    initialEtaHint: 'ETA Inicial a Puerto',
    realEta: 'ETA Real',
    realEtaHint: 'ETA Real a Puerto',
    estDelivery: 'Entrega Est.',
    estDeliveryHint: 'Entrega Estimada',
    realDelivery: 'Entrega Real',
    cost: 'Costo',
    lastUpdate: 'Últ. Act.',
    countSuffix: 'embarques',
    bulkEdit: 'Edición Masiva',
    bulkEditDescription: 'Actualizar {count} embarques seleccionados. Solo se modificarán los campos que completes.',
    noChange: 'Sin cambio',
    cancel: 'Cancelar',
    update: 'Actualizar',
    importFromExcel: 'Importar desde Excel',
    importExcelDescription: 'Sube un archivo Excel previamente exportado con los cambios que deseas aplicar.',
    instructions: 'Instrucciones:',
    clickToSelectFile: 'Haz clic para seleccionar archivo',
    onlyXlsx: 'Solo archivos .xlsx',
    processingFile: 'Procesando archivo...',
    // Loading / empty state
    loadingShipments: 'Cargando embarques...',
    noShipmentsFound: 'No se encontraron embarques',
    noActiveForClient: 'No tienes embarques activos',
    searchMbl: 'Buscar MBL...',
    // Bulk actions
    bulkEditCount: 'Editar',
    bulkRevalidate: 'Revalidar',
    bulkRevalidateTitle: 'Revalidar todos los embarques seleccionados contra las navieras (solo emergencia — la revalidación automática corre diariamente a las 5am Mexico)',
    revalidateShipmentTitle: 'Revalidar embarque contra naviera (solo emergencia — la revalidación automática corre diariamente)',
    revalidateShipmentConfirm: '¿Revalidar todos los contenedores de {mbl} contra la naviera? Se eliminarán datos falsos de puerto/ferrovalle si el carrier indica que los contenedores aún no han arribado.',
    revalidating: 'Revalidando embarque {mbl}...',
    bulkRevalidateConfirm: '¿Revalidar {count} embarque(s) seleccionado(s) contra las navieras? Se eliminarán datos falsos de puerto/ferrovalle si el carrier indica que los contenedores aún no han arribado. Esto puede tardar varios minutos.',
    bulkRevalidating: 'Revalidando {count} embarques...',
    bulkRevalidateResult: 'Revalidación masiva: {ok} OK · {fail} fallidos · Puerto purgado={port} · Ferrovalle={fer}',
    // Proforma
    prePedimentoOnlyPdf: 'Solo PDF',
    prePedimentoAnalyzing: 'Analizando proforma...',
    prePedimentoError: 'Error al procesar proforma',
    prePedimentoTitle: 'Subir proforma PDF — auto-detecta MBL, contenedor y asigna el número de pedimento',
    prePedimentoBulkTitle: 'Subir varias proformas PDF a la vez — extrae el número de cada una y lo asigna automáticamente (el PDF no se guarda)',
    // Repair
    repairConfirm: '¿Ejecutar reparación completa ahora?\n\nEsto corre:\n1. Ferrovalle scrape (busca containers pendientes)\n2. Port scrape\n3. Status sync (promueve estatus según datos nuevos)\n\nToma ~2-5 minutos. Es seguro — nunca baja status, solo promueve.',
    repairTriggered: 'Reparación disparada en background...',
    repairRunning: 'Reparación corriendo. Vuelve en 2-5 min y refresca para ver los cambios.',
    repairError: 'Error al disparar reparación',
    repairTitle: 'Reparar sincronización: corre Ferrovalle + Port + Status sync ahora',
    // ETAs
    etasOk: 'ETAs calculados para {count} embarques',
    etasNone: 'No hay embarques pendientes para calcular ETA',
    etasError: 'Error al calcular ETAs',
    etasTitle: 'Calcula ETA Entrega Estimada para embarques pendientes basado en datos históricos',
    // Delete dialog
    deleteShipmentTitle: 'Eliminar Embarque',
    deleteShipmentConfirm: '¿Estás seguro de eliminar el embarque',
    deleteShipmentOf: 'de',
    deleteShipmentWarn: 'Esta acción eliminará también todos los contenedores, eventos, notas y costos asociados.',
    deleteIrreversible: 'Esta acción no se puede deshacer.',
    deleteTitle: 'Eliminar embarque',
    deleting: 'Eliminando...',
    deletedOk: 'Embarque {mbl} eliminado',
    // Edit MBL dialog
    editMblTitle: 'Editar MBL',
    editMblDesc: 'Cambiar el número de MBL. Todos los datos relacionados (contenedores, eventos, notas) se actualizarán automáticamente.',
    currentMbl: 'MBL Actual',
    newMblLabel: 'Nuevo MBL',
    newMblPlaceholder: 'Nuevo número de MBL',
    editMblBtn: 'Editar MBL',
    // Container subtable
    containerLoading: 'Cargando contenedores...',
    noContainersRegistered: 'Sin contenedores registrados',
    containerNum: 'Contenedor',
    arrivalCol: 'Arribo',
    deliveryCol: 'Entrega',
    daysInPortCol: 'Días en Puerto',
    // Mobile card
    expand: 'Ver más',
    collapse: 'Ver menos',
    inactiveTag: '(inactivo)',
    noContainersFlag: 'Sin contenedores',
    docsPending: 'Docs pendientes',
    sentOn: 'Enviados',
    autoCalculated: 'Calculado automáticamente',
    bulkEditCountLabel: '({count})',
    selected: 'seleccionados',
    exportAll: 'Exportar todos',
    exportSelected: 'Exportar {count} seleccionados',
    excelLabel: 'Excel',
    excelLabelCount: 'Excel ({count})',
    importDocsTitle: 'Importar desde Notion',
    // Events tab
    newEvent: 'Nuevo Evento',
    eventType: 'Tipo de Evento',
    selectPlaceholder: 'Seleccionar',
    eventDate: 'Fecha',
    containerOptional: 'Contenedor (opcional)',
    blLevel: 'Nivel BL',
    visibleToClient: 'Visible cliente',
    noteOptional: 'Nota (opcional)',
    eventNotePlaceholder: 'Nota del evento...',
    addEvent: 'Agregar',
    noEventsRegistered: 'No hay eventos registrados',
    noEventsInCategory: 'No hay eventos en esta categoría',
    eventFilter: {
      all: 'Todos',
      aduana: 'Aduana',
      transporte: 'Transporte',
      almacen: 'Almacén',
    },
    internalOnly: 'Solo interno',
    // Notes tab
    newInternalNote: 'Nueva Nota Interna',
    noteLabel: 'Nota',
    notePlaceholder: 'Escribe la nota interna...',
    addNote: 'Agregar Nota',
    noClientNotes: 'No hay notas de aduana disponibles',
    noInternalNotes: 'No hay notas internas',
    noteSourceManual: 'Manual',
    noteSourceOutlook: 'Outlook',
    noteSourceSystem: 'Sistema',
    noteSourceSoia: 'SOIA / Aduana',
    visibleToClientBadge: 'Visible al cliente',
    // Detail page header / sections
    syncingNow: 'Sincronizando...',
    syncNow: 'Sincronizar ahora',
    syncNowTitle: 'Forzar actualización desde navieras, puertos y Ferrovalle',
    viewingAsClient: 'Estás viendo como cliente',
    customsSoia: 'Aduana / SOIA',
    // Info tab sections
    generalData: 'Datos Generales',
    datesAndEtas: 'Fechas y ETAs',
    importerSupplier: 'Importadora / Proveedor',
    operationCost: 'Costo de Operación',
    internalFields: 'Campos Internos',
    shipmentDocs: 'Documentos del Embarque',
    changeHistory: 'Historial de Cambios',
    pedimentosHeader: 'Pedimentos',
    // Field labels (detail)
    originLabel: 'Origen',
    destinationFinalLabel: 'Destino Final',
    arrivalPort: 'Puerto de Arribo',
    selectPort: 'Seleccionar puerto',
    addPortBtn: 'Agregar Puerto',
    portName: 'Nombre del Puerto',
    addPortTitle: 'Agregar nuevo puerto',
    incoterm: 'Incoterm',
    vessel: 'Buque',
    cargoTypeLabel: 'Tipo de Carga',
    cargoTypePh: 'Ej: FCL, LCL, Materia Prima, etc.',
    destinationPh: 'Ej: CDMX, Monterrey',
    portNamePh: 'Ej: Manzanillo',
    generalStatusLabel: 'Estatus General',
    activeLabel: 'Activo',
    etdOrigin: 'ETD Origen',
    originDepartureDate: 'Fecha de salida del origen',
    docsSentToAgent: 'Docs Enviados al Agente',
    docsSendDate: 'Fecha de envío de documentos',
    initialPortEta: 'ETA Inicial a Puerto',
    initialArrivalDate: 'Fecha estimada inicial de arribo',
    realPortEta: 'ETA Real a Puerto',
    realArrivalDate: 'Fecha real de arribo al puerto',
    estimatedDeliveryEta: 'ETA Entrega Estimada',
    estimatedDeliveryDate: 'Fecha estimada de entrega al cliente',
    realDeliveryLabel: 'Entrega Real',
    realDeliveryDate: 'Fecha real de entrega',
    createdAtLabel: 'Creado',
    lastUpdateLabel: 'Última actualización',
    notAssigned: 'Sin asignar',
    totalCostUsd: 'Costo Total (USD)',
    costCalculated: 'Costo Calculado',
    breakdownImage: 'Imagen Desglose',
    uploadBtn: 'Subir',
    currentBreakdown: 'Desglose Actual',
    costBreakdown: 'Desglose de Costos',
    finalQuoteDone: 'Cotización Final Realizada',
    arnulfoApplies: 'Aplica Arnulfo',
    arnulfoStatus: 'Estatus Arnulfo',
    arnulfoPending: 'Pendiente',
    journeyOrigin: 'Origen',
    journeyOriginShort: 'Origen',
    journeyTransit: 'En Transito',
    journeyTransitShort: 'Transito',
    journeyPort: 'En Puerto',
    journeyPortShort: 'Puerto',
    journeyLand: 'Transito Terrestre',
    journeyLandShort: 'Terrestre',
    journeyTrain: 'Tren / Ferrovalle',
    journeyTrainShort: 'Tren',
    journeyDelivered: 'Entregado',
    journeyDeliveredShort: 'Entregado',
    arnulfoPaid: 'Pagado',
  },
  reports: {
    title: 'Reporte Mensual',
    subtitle: 'Resumen de operaciones por mes. Se envia automaticamente el dia 1 de cada mes.',
    preview: 'Vista Previa',
    sendByEmail: 'Enviar por Email',
    loadError: 'Error al cargar el reporte',
    sentOk: 'Reporte enviado por email',
    sendError: 'Error al enviar el reporte',
    metrics: {
      totalShipments: 'Embarques Totales',
      containers: 'Contenedores',
      delivered: 'Entregados',
      active: 'Activos',
      inPort: 'En Puerto',
      certsExpiring: 'Certs x Vencer',
    },
    period: 'Periodo',
    newShipments: 'Embarques nuevos',
    arrivalsThisMonth: 'Arribos del mes',
    deliveriesThisMonth: 'Entregas del mes',
    inTransitToMexico: 'En camino a Mexico',
    avgDaysInPort: 'Prom. dias desde arribo',
    days: 'dias',
    shipmentsByStatus: 'Embarques por Estatus',
    importers: 'Importadoras',
    noImportersData: 'Sin datos de importadoras para este periodo',
    upcomingRenewals: 'Renovaciones Proximas (30 dias)',
    contractTag: 'Contrato',
    certificateTag: 'Certificado',
    months: {
      1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio',
      7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre',
    },
    statusLabels: {
      NO_SALIDO_CHINA: 'No Salido de China',
      EN_TRANSITO_PUERTO: 'En Transito Maritimo',
      ARRIBADO_PUERTO: 'Arribado a Puerto',
      EN_TRANSITO_TERRESTRE: 'En Transito Terrestre',
      ENTREGADO: 'Entregado',
      ENTREGADO_PEND_DEMORAS: 'Entregado (Pend. Demoras)',
    },
  },
  superAdmin: {
    title: 'Dashboard SaaS',
    subtitle: 'Panel de administracion SaaS',
    exportShipments: 'Exportar Cargas',
    importJson: 'Importar JSON',
    exportTitle: 'Exportar cargas pendientes como JSON (migrar prod → preview)',
    importTitle: 'Importar bundle JSON desde otro entorno',
    newClient: 'Nuevo Cliente',
    newClientTitle: 'Nuevo Cliente / Organizacion',
    name: 'Nombre',
    namePh: 'Nombre de la empresa',
    type: 'Tipo',
    plan: 'Plan',
    contactEmail: 'Email de contacto',
    create: 'Crear',
    clients: 'Clientes',
    searchPh: 'Buscar...',
    organization: 'Organizacion',
    pricePerMonth: 'Precio/mes',
    state: 'Estado',
    users: 'Usuarios',
    shipments: 'Embarques',
    contact: 'Contacto',
    actionsCol: 'Acciones',
    noClients: 'Sin clientes registrados',
    customOverride: 'Override custom',
    edit: 'Editar',
    enterPortal: 'Entrar al portal',
    invite: 'Invitar',
    delete: 'Eliminar',
    editOrg: 'Editar',
    subscription: 'Suscripcion',
    cycle: 'Ciclo',
    monthly: 'Mensual',
    yearly: 'Anual',
    typeComercializadora: 'Comercializadora',
    typeAgenteAduanal: 'Agente Aduanal',
    typeCliente: 'Cliente',
    statusActive: 'Activa',
    statusInactive: 'Inactiva',
    activate: 'Activar',
    deactivate: 'Desactivar',
    monthlyOverride: 'Precio mensual (override)',
    monthlyOverridePh: 'Dejar vacio para usar precio del plan',
    saveChanges: 'Guardar Cambios',
    deleteConfirm: '¿Seguro que deseas eliminar la organizacion {name}? Esta accion eliminara todos sus usuarios y datos.',
    deleteConfirm2: 'Confirma escribiendo el nombre de la organizacion',
    enterPortalConfirm: '¿Entrar al portal de {name} como administrador? Tu sesion actual quedara guardada.',
    confirmEnter: 'Entrar',
    inviteUser: 'Invitar Usuario',
    inviteEmail: 'Email del nuevo usuario',
    inviteName: 'Nombre',
    inviteRole: 'Rol',
    sendInvite: 'Enviar Invitacion',
    manageUsers: 'Gestionar Usuarios',
    noUsers: 'Sin usuarios',
    removeUser: 'Eliminar Usuario',
    confirmRemove: '¿Eliminar este usuario? Esta accion no se puede deshacer.',
    backToOrgs: 'Volver',
    statsActiveOrgs: 'Organizaciones Activas',
    statsTotalUsers: 'Usuarios Totales',
    statsTotalShipments: 'Embarques Totales',
    statsTotalContainers: 'Contenedores',
    statsMrr: 'MRR',
    statsArr: 'ARR',
    monthlyRecurring: 'Mensual recurrente',
    annualRecurring: 'Anual recurrente',
    overall: 'En total',
    editOrgTitle: 'Editar',
    nameField: 'Nombre',
    emailContact: 'Email Contacto',
    maxOperators: 'Max Operadores',
    maxClients: 'Max Clientes',
    nextPayment: 'Próximo Pago',
    monthlyPriceOverride: 'Precio mensual (override)',
    overrideHelp: 'Vacío = usar precio del plan',
    featuresActive: 'Features Activas',
    internalNotes: 'Notas internas',
    notesPh: 'Notas sobre este cliente...',
    inviteUserTo: 'Invitar Usuario a',
    emailLabel: 'Email',
    emailPh: 'email@usuario.com',
    fullNamePh: 'Nombre completo',
    roleLabel: 'Rol',
    roleOps: 'Operador',
    roleClient: 'Cliente',
    roleAdmin: 'Admin',
    sendInvitation: 'Enviar Invitación',
    usersOf: 'Usuarios de',
    impersonateTitle: 'Entrar como este usuario',
    activeUser: 'Activo',
    inactiveUser: 'Inactivo',
    inviteUserBtn: 'Invitar Usuario',
    featLabel: {
      shipments: 'Embarques',
      containers: 'Contenedores',
      events: 'Eventos',
      internal_notes: 'Notas Internas',
      dashboard: 'Dashboard',
      client_portal: 'Portal Cliente',
      tracking_ports: 'Tracking Puertos',
      tracking_carriers: 'Tracking Navieras',
      document_generation: 'Generación Docs',
      cost_breakdown: 'Costos',
      certificates: 'Certificados',
      alerts: 'Alertas',
      monthly_report: 'Reporte Mensual',
      sla_dashboard: 'Dashboard SLA',
      multi_user: 'Multi-Usuario',
      excel_export: 'Exportar Excel',
      audit_history: 'Historial',
      client_arnulfo: 'Dashboard Arnulfo (Cliente)',
      client_force_soia: 'Forzar SOIA (Cliente)',
    },
  },
  statusCodes: {
    NO_SALIDO_CHINA: 'No Salido de China',
    BOOKING_NO_SALIDO: 'Booking - No Salido',
    EN_TRANSITO_PUERTO: 'En Tránsito a Puerto',
    EN_TRANSITO_MARITIMO: 'En Tránsito Marítimo',
    EN_TRANSITO: 'En Tránsito',
    ARRIBADO_PUERTO: 'Arribado a Puerto',
    EN_PUERTO: 'En Puerto',
    EN_PUERTO_LIBERACION: 'En Proceso de Liberación',
    EN_PUERTO_LIBERADO: 'En Puerto - Liberado',
    EN_PUERTO_SEMAFORO_ROJO: 'En Puerto - Semáforo Rojo',
    EN_PUERTO_CARGA_FERRO: 'En Puerto - Proceso de Carga a Ferro',
    EN_TRANSITO_TERRESTRE: 'En Tránsito Terrestre',
    EN_PANTACO: 'En Pantaco',
    EN_DESTINO: 'En Destino',
    ENTREGADO: 'Entregado',
    ENTREGADO_PEND_DEMORAS: 'Entregado / Pendiente Demoras',
    NO_ARRIBADO: 'No Arribado',
    DESPACHO_EN_PROCESO: 'Despacho En Proceso',
    LIBERADO: 'Liberado',
    LLEGADA_PATIO: 'Llegada a Patio',
  },
  trafficLight: {
    GREEN: 'Libre',
    GREEN_TitleHelp: 'Libre',
    RED: 'Inspección',
    NA: 'N/A',
    NA_TitleHelp: 'No Aplica',
  },
  costStatus: {
    pending: 'Pendiente',
    calculated: 'Calculado',
  },
  onboarding: {
    skip: 'Saltar tour',
    next: 'Siguiente',
    back: 'Atrás',
    finish: 'Comenzar',
    stepOf: 'Paso {current} de {total}',
    dontShowAgain: 'No volver a mostrar',
    // Common steps
    welcomeTitle: 'Bienvenido a OFIMEX',
    welcomeBody: 'Tu plataforma para gestionar importaciones a México de inicio a fin: tracking en tiempo real desde la naviera hasta el puerto y Ferrovalle, automatización de pedimentos, alertas SLA y reportes mensuales.',
    // Operator
    opsTrackingTitle: 'Tracking conectado',
    opsTrackingBody: 'OFIMEX se conecta con las navieras (MSC, Evergreen, COSCO, Hapag, Maersk, ONE, OOCL, ZIM, etc.), los puertos (Contecon, TIMSA, SSA Manzanillo) y Ferrovalle.',
    opsAlertsTitle: 'Alertas y reportes',
    opsAlertsBody: 'Configura alertas por contenedor con días desde arribo, ETA pendiente o documentos sin enviar en /alerts. El reporte mensual se genera y envía cada día 1.',
    // Client
    clientTrackingTitle: 'Sigue tus embarques en tiempo real',
    clientTrackingBody: 'En /shipments verás el estatus general, el contenedor, fecha estimada de arribo y entrega de cada uno de tus embarques. Haz clic en el MBL para ver la línea de tiempo completa.',
    clientDocsTitle: 'Documentos y pedimentos',
    clientDocsBody: 'Cuando tu agente aduanal tramite el pedimento, lo verás aparecer automáticamente en el detalle del embarque junto con tus documentos asociados (BL, factura, certificados).',
    clientNotifTitle: 'Notificaciones por email',
    clientNotifBody: 'Cuando tu contenedor arribe a puerto, sea liberado o salga rumbo a Ferrovalle, recibirás un correo. Configura tus alertas en /alerts.',
    // Operator (full ops flow)
    opsCreateTitle: 'Crear y editar embarques',
    opsCreateBody: 'Desde /shipments puedes dar de alta un BL nuevo (botón "+ Nuevo Embarque") asignando cliente, importador, MBL y vessel. Para editar, entra al detalle del BL — el botón ✎ junto al MBL te permite cambiar el número en cualquier momento.',
    opsDocsTitle: 'Documentos, pedimentos y costos',
    opsDocsBody: 'En la pestaña "Documentos" subes BL, factura y certificados. La pestaña "Pedimentos" lee automáticamente datos del XML. En "Costos" registras pagos al puerto, naviera y aduanas.',
    opsDeliveryTitle: 'Marcar entregado y notificar',
    opsDeliveryBody: 'OFIMEX detecta automáticamente cuando el container regresa vacío a Ferrovalle ("FI Vacíos") y lo marca como entregado, enviando el email al cliente. Si necesitas marcarlo manualmente, lo haces desde la pestaña Información.',
    // Admin
    adminUsersTitle: 'Usuarios y permisos',
    adminUsersBody: 'En /users gestionas tu equipo: agregar operadores, asignar permisos granulares por módulo (embarques, pagos, costos, certificados) y restringir acceso a clientes a su propia data.',
    adminAuditTitle: 'Audit Logs y rastreabilidad',
    adminAuditBody: 'En /super-admin/audit-logs ves cada acción del sistema (creación, edición, sync, login). Útil para auditorías o investigar quién cambió qué.',
    adminTrackingHealthTitle: 'Salud del Tracking',
    adminTrackingHealthBody: 'En el panel Super Admin verás "Salud del Tracking" — estado en vivo de los 4 scrapers (Naviera, Puerto, Ferrovalle, SOIA). Si Ferrovalle falla login te avisa con banner rojo y puedes reintentar al instante.',
    adminReportsTitle: 'Reportes mensuales y SLA',
    adminReportsBody: 'En /reports descargas el reporte mensual (PDF + CSV). En /sla mides KPIs operativos: tiempo promedio puerto-cliente, % entregas a tiempo, demoras. Se envía automáticamente cada día 1.',
    // Super Admin (OFIMEX staff)
    superMultiTenantTitle: 'Vista multi-organización',
    superMultiTenantBody: 'Como Super Admin, en /super-admin ves todas las organizaciones (orgs) usando OFIMEX, sus métricas y planes contratados. Cada org tiene sus propios usuarios, embarques y permisos aislados.',
    superViewAsTitle: 'Modo "View As" (inspección)',
    superViewAsBody: 'Puedes entrar a una org en modo lectura para diagnosticar sin tocar su data. Activa "Editar" si necesitas hacer un cambio manual. Todo queda registrado en Audit Logs con tu identidad.',
    superDiagnosticsTitle: 'Diagnósticos de plataforma',
    superDiagnosticsBody: 'Botón "Enviar email de prueba" para validar Resend, panel de "Salud del Tracking" para los 4 scrapers, y Audit Logs cross-org. Todo desde /super-admin.',
  },
  manual: {
    title: 'Manuales',
    description: 'Descarga los manuales en PDF para compartirlos con tu equipo y tus clientes.',
    opsLabel: 'Manual del Operador',
    opsDescription: 'Para tu equipo interno: cómo gestionar embarques, subir proformas, ver alertas y reportes.',
    clientLabel: 'Manual del Cliente',
    clientDescription: 'Para enviárselo a tus clientes / importadoras finales: cómo seguir embarques y descargar pedimentos.',
    download: 'Descargar PDF',
    downloading: 'Descargando...',
    downloadError: 'No se pudo descargar el manual',
    sidebarLink: 'Manuales',
    tourLabel: 'Ver tour de bienvenida',
    tourDescription: 'Repite el recorrido rápido de 4 pasos sobre cómo funciona OFIMEX.',
    tourButton: 'Ver tour',
  },
  // Tracking
  tracking: {
    title: 'Tracking de Contenedores',
    subtitle: 'Rastreo directo con las navieras',
    track: 'Rastrear',
    searchPlaceholder: 'Buscar contenedor, MBL o cliente...',
    noActiveContainers: 'No hay contenedores activos',
    allCarriers: 'Todos',
    updateStatus: 'Actualizar Estado',
    updateAll: 'Actualizar Todos',
    usingCachedData: 'Usando datos en cache (reciente)',
    dataUpdated: 'Datos de tracking actualizados',
    scrapeError: 'No se pudo obtener datos automaticamente',
    scrapeAllStarted: 'Actualizacion masiva iniciada en segundo plano',
    lastScraped: 'Ultima consulta',
    scrapedStatus: 'Estado obtenido',
    location: 'Ubicacion',
    vessel: 'Buque',
    eta: 'ETA',
    origin: 'Origen',
    destination: 'Destino',
    events: 'Eventos de tracking',
    noAutoData: 'No se pudo obtener datos automaticos. Usa el enlace directo:',
    visitPortal: 'Ir al portal de la naviera',
    unknown: 'Desconocida',
    portResultsFound: 'resultado(s) encontrado(s)',
    portNoResults: 'Sin resultados para este contenedor',
    portError: 'Error consultando terminal portuaria',
    portNoContainers: 'No hay contenedores validos para consultar',
    portLoading: 'Error cargando contenedores',
    portNoneFound: 'Ningun contenedor encontrado en terminal',
    timelineTitle: 'Timeline de Seguimiento',
  },
  // Certificates
  certificates: {
    title: 'Certificados',
    subtitle: 'Gestion de certificados de producto',
    product: 'Producto',
    fraction: 'Fraccion',
    model: 'Modelo',
    expirationDate: 'Fecha Expiracion',
    daysRemaining: 'días restantes',
    daysExpired: 'Vencido',
    importerName: 'Importadora',
    addCertificate: 'Nuevo Certificado',
    editCertificate: 'Editar Certificado',
    noCertificates: 'No hay certificados',
    valid: 'Vigente',
    expiringSoon: 'Por vencer',
    expired: 'Vencido',
    searchPlaceholder: 'Buscar producto, fraccion, modelo...',
    noCertificatesFound: 'No se encontraron certificados',
    product: 'Producto',
    fraction: 'Fraccion Arancelaria',
    model: 'Modelo',
    certificateNumber: 'No. Certificado',
    expirationDate: 'Fecha de Expiracion',
    issuingAuthority: 'Autoridad Emisora',
    allStatuses: 'Todos los estatus',
    errorLoading: 'Error al cargar certificados',
    errorSaving: 'Error al guardar certificado',
    errorDeleting: 'Error al eliminar certificado',
    savedOk: 'Certificado guardado',
    deletedOk: 'Certificado eliminado',
    productCertificate: 'Certificado',
    contract: 'Contrato',
    certificate: 'Certificado',
    contractName: 'Nombre del Contrato',
    fileUploaded: 'Archivo subido correctamente',
    fileUploadError: 'Error al subir archivo',
  },
  // Email Settings
  emailSettings: {
    title: 'Correo Entrante',
    subtitle: 'Conecta tu correo para recibir actualizaciones automaticas de embarques',
    imapConfig: 'Configuracion IMAP',
    imapHost: 'Servidor IMAP',
    port: 'Puerto',
    emailAddress: 'Correo electronico',
    passwordLabel: 'Contrasena',
    passwordSet: 'ya configurada',
    leaveEmpty: 'Dejar vacio para mantener',
    appPasswordHint: 'Para Gmail, usa una "App Password" generada en tu cuenta de Google',
    folder: 'Carpeta',
    interval: 'Intervalo (minutos)',
    useSSL: 'Usar SSL',
    testConnection: 'Probar Conexion',
    checkNow: 'Revisar Ahora',
    parsedEmails: 'Emails Recibidos',
    applyData: 'Aplicar Datos',
    dismiss: 'Descartar',
    pendingEmails: 'Pendientes',
    applied: 'Aplicados',
    dismissed: 'Descartados',
    notRelevant: 'No relevantes',
    lastCheck: 'Ultima revision',
    extractedData: 'Datos Extraidos',
    detectedStatus: 'Estatus detectado',
    noEmails: 'No hay emails',
    noSubject: '(sin asunto)',
    containersFound: 'Contenedores',
    mblsFound: 'MBLs',
    hostRequired: 'Host IMAP y correo son obligatorios',
    passwordRequired: 'Ingresa la contrasena',
    configSaved: 'Configuracion guardada',
    errorSaving: 'Error al guardar',
    errorTestingConn: 'Error al probar conexion',
    errorLoadingEmails: 'Error al cargar emails',
    errorCheckingInbox: 'Error al revisar inbox',
    errorApplying: 'Error al aplicar',
    emailDismissed: 'Email descartado',
    errorDismissing: 'Error al descartar',
    errorLoadingConfig: 'Error al cargar configuracion',
  },
  // Audit
  audit: {
    title: 'Historial de Auditoria',
    subtitle: 'Registro de cambios en el sistema',
    entity: 'Entidad',
    action: 'Accion',
    user: 'Usuario',
    changes: 'Cambios',
    oldValue: 'Anterior',
    newValue: 'Nuevo',
    noAuditLogs: 'No hay registros de auditoria',
    created: 'Creado',
    updated: 'Actualizado',
    deleted: 'Eliminado',
  },
  // Alerts
  alerts: {
    title: 'Configuracion de Alertas',
    subtitle: 'Define umbrales y destinatarios para alertas automaticas',
    daysInPort: 'Dias en Puerto',
    daysSinceArrival: 'Dias desde Arribo',
    expiringCertificates: 'Certificados por Vencer',
    recipients: 'Destinatarios',
    threshold: 'Umbral (dias)',
    enabled: 'Habilitada',
    disabled: 'Deshabilitada',
    runNow: 'Ejecutar Ahora',
    addRecipient: 'Agregar destinatario',
    emailPlaceholder: 'correo@ejemplo.com',
    configSaved: 'Configuracion guardada',
    errorSaving: 'Error al guardar configuracion',
    errorLoading: 'Error al cargar alertas',
    alertsSent: 'Alertas enviadas',
    testSent: 'Alerta de prueba enviada',
    errorSending: 'Error al enviar alertas',
    errorTesting: 'Error al enviar alerta de prueba',
    checkNow: 'Verificar Ahora',
    activated: 'Alerta activada',
    deactivated: 'Alerta desactivada',
    errorUpdating: 'Error al actualizar',
    invalidEmail: 'Ingresa un email valido',
    recipientAdded: 'Destinatario agregado',
    recipientRemoved: 'Destinatario eliminado',
    errorAddingRecipient: 'Error al agregar destinatario',
    errorRemovingRecipient: 'Error al eliminar destinatario',
    sendTestEmail: 'Enviar Correo de Prueba',
    add: 'Agregar',
    nameOptional: 'Nombre (opcional)',
    noRecipientsConfigured: 'No hay destinatarios configurados',
    alertHistory: 'Historial de Alertas Enviadas',
    noAlertsSent: 'No se han enviado alertas aun',
    daysInPortLog: 'dias en puerto',
    daysSinceArrivalLog: 'dias desde arribo',
    sentTo: 'Enviado a',
    days: 'dias',
    checkCompleted: 'Verificacion completada',
  },
  // Pricing
  pricing: {
    title: 'Precios Historicos',
    subtitle: 'Historial de precios por producto y cliente',
    product: 'Producto',
    clientName: 'Cliente',
    price: 'Precio',
    currency: 'Moneda',
    priceDate: 'Fecha',
    addEntry: 'Nuevo Registro',
    noPrices: 'No hay registros de precios',
    priceHistory: 'Historial de Precios',
    errorLoading: 'Error al cargar precios',
    errorSaving: 'Error al guardar precio',
    errorDeleting: 'Error al eliminar precio',
    savedOk: 'Precio guardado',
    deletedOk: 'Precio eliminado',
    editPrice: 'Editar Precio',
    newPriceEntry: 'Nuevo Registro de Precio',
    totalRecords: 'Total Registros',
    products: 'Productos',
    searchPlaceholder: 'Buscar producto, item, proveedor...',
    allClients: 'Todos los clientes',
    itemNumber: 'Item #',
    supplier: 'Proveedor',
    unitPrice: 'Precio Unitario',
    quantity: 'Cantidad',
    effectiveDate: 'Fecha Efectiva',
    originCountry: 'Pais de Origen',
    productRequired: 'Producto y precio son requeridos',
    masterAdminOnly: 'Solo Master Admin puede ver precios',
    confirmDelete: 'Seguro que deseas eliminar este registro?',
    recordsImported: 'registros importados',
    rowsWithErrors: 'filas con errores',
    emptyFile: 'El archivo no contiene registros validos',
    errorImporting: 'Error al importar precios',
    bulkUpload: 'Importar CSV',
    downloadTemplate: 'Descargar Plantilla',
    uploading: 'Importando...',
  },
  // Clients / Importers / Suppliers
  entities: {
    clients: 'Clientes',
    addClient: 'Nuevo Cliente',
    editClient: 'Editar Cliente',
    noClients: 'No hay clientes',
    importers: 'Importadoras',
    addImporter: 'Nueva Importadora',
    editImporter: 'Editar Importadora',
    noImporters: 'No hay importadoras',
    suppliers: 'Proveedores',
    addSupplier: 'Nuevo Proveedor',
    editSupplier: 'Editar Proveedor',
    noSuppliers: 'No hay proveedores',
    contactName: 'Nombre de contacto',
    phone: 'Telefono',
    address: 'Direccion',
    rfc: 'RFC',
    legalRepName: 'Representante Legal',
    docs: 'Documentos',
    uploadLogo: 'Subir Logo',
    uploadSignature: 'Subir Firma',
    signature: 'Firma',
    errorLoading: 'Error al cargar datos',
    errorSaving: 'Error al guardar',
    errorToggle: 'Error al cambiar estado',
    savedOk: 'Guardado exitosamente',
    stateChanged: 'Estado actualizado',
  },
  // Users
  users: {
    title: 'Usuarios',
    subtitle: 'Administracion de usuarios del sistema',
    addUser: 'Nuevo Usuario',
    editUser: 'Editar Usuario',
    role: 'Rol',
    admin: 'Administrador',
    ops: 'Operaciones',
    clientRole: 'Cliente',
    active: 'Activo',
    inactive: 'Inactivo',
    noUsers: 'No hay usuarios',
    resetPassword: 'Restablecer Contrasena',
    noChange: 'Sin cambio',
    operator: 'Operador',
    loadError: 'Error al cargar usuarios',
    requiredFields: 'Nombre, email y contrasena son requeridos',
    clientRequired: 'Debes seleccionar un cliente para usuarios tipo cliente',
    userCreated: 'Usuario creado. Se envio email de bienvenida.',
    createError: 'Error al crear usuario',
    statusUpdated: 'Estado actualizado',
    statusError: 'Error al cambiar estado',
    masterRoleError: 'Error al cambiar rol de admin maestro',
    userDeleted: 'Usuario eliminado',
    deleteError: 'Error al eliminar usuario',
    noChange: 'Sin cambiar',
    operator: 'Operador',
    client: 'Cliente',
    administrator: 'Administrador',
    initialPassword: 'Contrasena inicial',
    associatedClient: 'Cliente asociado',
    selectClient: 'Seleccionar cliente',
    welcomeEmailNote: 'Se enviara un email de bienvenida con link para configurar contrasena.',
    confirmDelete: 'Estas seguro de eliminar al usuario',
    bulkEdit: 'Edicion Masiva',
    bulkEditDescription: 'Actualizar usuarios seleccionados. Solo se modificaran los campos que completes.',
    noUsers: 'No hay usuarios registrados',
  },
  // Catalogs
  catalogs: {
    title: 'Catalogos',
    subtitle: 'Administra los catalogos del sistema',
    generalStatus: 'Estatus Generales',
    containerStatus: 'Estatus de Contenedor',
    eventTypes: 'Tipos de Evento',
    addItem: 'Nuevo Item',
    editItem: 'Editar Item',
    code: 'Codigo',
    label: 'Etiqueta',
    order: 'Orden',
    errorLoading: 'Error al cargar catalogos',
    errorSaving: 'Error al guardar',
    savedOk: 'Item guardado',
    showInactive: 'Mostrar inactivos',
    noItems: 'No hay items en este catalogo',
    codeHelp: 'Identificador unico (sin espacios)',
    shipmentStatus: 'Estatus Embarque',
    incoterms: 'Incoterms',
    maintenance: 'Herramientas de Mantenimiento',
    cleanMbls: 'Limpiar MBLs',
    cleanMblsDesc: 'Corrige espacios en blanco y caracteres especiales en los numeros de BL/MBL.',
    cleanMblsConfirm: 'Deseas ejecutar la limpieza de MBLs?',
    cleaning: 'Limpiando...',
    runCleanup: 'Ejecutar Limpieza',
    findDuplicates: 'Buscar Duplicados',
    removeDuplicates: 'Eliminar Duplicados',
    removeDuplicatesTitle: 'Eliminar Duplicados',
    removeDuplicatesDesc: 'Busca y elimina embarques duplicados (mismo MBL). Mantiene el registro mas completo.',
    removeDuplicatesConfirm: 'Deseas eliminar los embarques duplicados?',
    searching: 'Buscando...',
    removing: 'Eliminando...',
    noDuplicates: 'No hay duplicados',
    duplicatesFound: 'Encontrados grupos de duplicados',
    records: 'registros',
    migrateStatuses: 'Actualizar Catalogos de Estatus',
    migrateStatusesDesc: 'Actualiza los catalogos de estatus al nuevo formato (12 de embarque, 11 de contenedor).',
    migrateStatusesConfirm: 'Deseas actualizar los catalogos de estatus al nuevo formato?',
    migrating: 'Migrando...',
    migrateNow: 'Actualizar Estatus Ahora',
  },
  // Payments
  payments: {
    title: 'Pagos',
    subtitle: 'Control de pagos y saldos de clientes',
    paymentsBalance: 'Balance de Pagos',
    paymentsBalanceSubtitle: 'Gestiona pagos recibidos y balances por cliente',
    registerPayment: 'Registrar Pago',
    accountsReceivable: 'Cuentas por Cobrar',
    totalPaid: 'Total Pagado',
    pendingBalanceLabel: 'Saldo Pendiente',
    activeClients: 'Clientes Activos',
    balancesByClient: 'Balances por Cliente',
    paymentHistory: 'Historial de Pagos',
    search: 'Buscar...',
    client: 'Cliente',
    shipmentsCol: 'Embarques',
    totalCost: 'Costo Total',
    paymentsCol: 'Pagos',
    balanceCol: 'Saldo',
    noBalanceData: 'No hay datos de balance',
    owes: 'Debe',
    inFavor: 'A favor',
    paymentMethodSummary: 'Resumen por Metodo de Pago',
    allClients: 'Todos los clientes',
    selectClient: 'Seleccionar cliente',
    initialBalance: 'Saldo Inicial',
    pendingBalance: 'Saldo pendiente de operaciones anteriores a OFIMEX',
    amountDateRequired: 'Ingresa el monto y la fecha',
    initialBalanceSaved: 'Saldo inicial guardado',
    saveError: 'Error al guardar saldo inicial',
    paymentDeleted: 'Pago eliminado',
    deleteError: 'Error al eliminar',
    paymentUpdated: 'Pago actualizado',
    paymentRegistered: 'Pago registrado',
    loadError: 'Error al cargar datos',
    clientDetailError: 'Error al cargar detalle del cliente',
  },
  // Organizations
  organizations: {
    title: 'Organizaciones',
    subtitle: 'Gestion de leads y organizaciones',
    newStatus: 'Nuevo',
    contacted: 'Contactado',
    converted: 'Convertido',
    rejected: 'Rechazado',
    paymentPending: 'Pago Pendiente',
    paymentPendingDesc: 'No se ha recibido el pago del mes',
    paymentOverdue: 'Pago Vencido',
    paymentOverdueDesc: 'El pago tiene mas de 30 dias de retraso',
    contractEnded: 'Contrato Terminado',
    contractEndedDesc: 'El contrato ha finalizado',
    clientRequested: 'Solicitud del Cliente',
    clientRequestedDesc: 'El cliente solicito la desactivacion',
    other: 'Otro',
    otherDesc: 'Otro motivo',
    leadDeleted: 'Lead eliminado',
    deleteError: 'Error al eliminar lead',
    statusUpdated: 'Estado actualizado',
    statusError: 'Error al actualizar',
    loadError: 'Error al cargar datos',
  },
  documents: {
    title: 'Documentos',
    subtitle: 'Gestion de documentos por embarque',
    generateInvoicePL: 'Generar Invoice + PL',
    generated: 'Documento generado',
    errorGenerating: 'Error al generar documento',
    supplierName: 'Nombre del Proveedor',
    supplierAddress: 'Direccion del Proveedor',
    invoiceNo: 'No. Factura',
    invoiceDate: 'Fecha Factura',
    shipmentDate: 'Fecha Embarque',
    signatory: 'Firmante',
    importer: 'Importadora',
    container: 'Contenedor',
    vessel: 'Buque',
    items: 'Productos / Items',
    addItem: 'Agregar Item',
    description: 'Descripcion',
    price: 'Precio',
    qty: 'Cantidad',
    unit: 'Unidad',
    downloadXLSX: 'Descargar XLSX',
    aluminumManualOnly: 'Contenedores de aluminio requieren Invoice/PL manual',
    manualInvoiceOnly: 'Invoice Manual (Aluminio)',
    generateCarta: 'Carta Explicacion',
    cartaDate: 'Fecha de Carta',
    invoiceNo: 'No. Factura',
    invoiceDate: 'Fecha Factura',
    destinationPort: 'Puerto Destino',
    customsRegime: 'Regimen Aduanero',
    containers: 'Contenedores',
    cartaGenerated: 'Carta generada exitosamente',
    downloadDOCX: 'Descargar DOCX',
    invoiceNoRequired: 'El numero de factura es requerido',
    errorGenerating: 'Error al generar documento',
  },
  arnulfo: {
    pagado: 'Pagado',
    pendiente: 'Pendiente',
    noAplica: 'No Aplica',
    noPermission: 'No tienes permiso para acceder a esta pagina',
    statusUpdated: 'Status actualizado',
    errorUpdating: 'Error al actualizar status',
  },
  // Register
  register: {
    title: 'Solicitar Acceso',
    companyRequired: 'El nombre de la empresa es requerido',
    emailRequired: 'El email es requerido',
    passwordRequired: 'La contrasena es requerida',
    passwordMinLength: 'La contrasena debe tener al menos 6 caracteres',
    passwordsMismatch: 'Las contrasenas no coinciden',
    success: 'Registro exitoso',
    error: 'Error al registrar',
    step1: 'Nuestro equipo revisara tu solicitud',
    step2: 'Recibiras confirmacion por email',
    step3: 'Podras acceder con tus credenciales',
    createAccount: 'Crear Cuenta',
    free: 'Gratis',
  },
  clientDash: {
    title: 'Mi Panel',
    subtitle: 'Resumen de tus embarques',
    activeShipments: 'Embarques Activos',
    containers: 'Contenedores',
    inProcess: 'En Proceso',
    deliveredMonth: 'Entregados (30d)',
    activitySummary: 'Resumen de Actividad',
    inTransit: 'En Transito',
    atPort: 'En Puerto/Proceso',
    delivered: 'Entregados',
    recentShipments: 'Mis Embarques Recientes',
    noShipments: 'No tienes embarques recientes',
    statusByShipment: 'Embarques por Estatus',
  },
};

export default es;
